import { StoreExt } from '@utils/reactExt'
import { observable, action, runInAction } from 'mobx'
import { userStore } from '@store/userStore'
import { FORMAT_TYPES } from '@src/constants';
import moment from 'moment'
import { lotteryStore } from '@views/ordering/lottery/actor/store'
import { deepClone } from '@src/utils';

class PackageDetailStore extends StoreExt {
    @observable loading: boolean = true;
    @observable readFlag: boolean = false;
    @observable showUpgradeForActive: boolean = false;
    @observable upgradeForActiveDto: object = {};
    @action
    setObservableData = (key, value) => {
        this[key] = value
    }
    @action
    changeBox = (e) => {
        runInAction(() => {
            this.readFlag = e.target.checked
        })
    }
    /**
     * 激活套餐
     * @param {string} simId
     * @param {string} activityId
     * @param {function} callback  海外平板的回调
     * @returns {Promise<void>}
     */
    @action
    activePackage = async ({ simId, activityId = '', goodsReleaseId = '' }) => {
        try {
            const res = await this.api.active({ simId: simId, activityId: activityId, goodsReleaseId: goodsReleaseId });
            // 查询新人礼配置项
            const Gfitres = await this.api.getqueryMeetingGift({
                iccid: userStore.currentDeviceInfo.simId
            })
            await userStore.getDeviceDetail(userStore.currentDeviceInfo.simId);
            if (Gfitres.meetingStatus === '0' && Gfitres.plans.length > 0) {
                this.goToPath(`/app/MeetingGift`)
            }
            res.startUseDate = res.startUseDate ? moment(res.startUseDate).format(FORMAT_TYPES.DOT_DATE) : null
            res.endDate = res.endDate ? moment(res.endDate).format(FORMAT_TYPES.DOT_DATE) : null
            const initPackageArr = deepClone(userStore.initPackageArr) || [];
            if (initPackageArr.length <= 1) {
                userStore.setFreeSuccess(true, res) // todo
                userStore.setShowActiveTipMask(false, simId)
            }
            if (location.href.indexOf('activing') > -1) { // 详情页激活的
                this.goToPath('/app/home')
                userStore.setActiveState('done')
                userStore.setShowActiveTipMask(true)
            }
            // 引导用户升级
            this.querySelectUpgrade(simId, goodsReleaseId);
            // 激活触发抽奖活动
            // author - chenkai
            lotteryStore.getLotteryInfo()
        } catch (e) {
        }
    }

    @action
    querySelectUpgrade = async (iccid, goodsReleaseId) => {
        let flag = false;
        let upgradeForActiveDto = {};
        try {
            const res = await this.api.querySelectUpgrade({ iccid, goodsReleaseId });
            flag = res.length > 0;
            upgradeForActiveDto = res[0]
        } catch (e) {
            flag = false;
            upgradeForActiveDto = {}
        } finally {
            runInAction(() => {
                this.showUpgradeForActive = flag;
                this.upgradeForActiveDto = upgradeForActiveDto
            })
        }
    }
}

const packageDetailStore = new PackageDetailStore()
export { packageDetailStore, PackageDetailStore }
